import React ,{Fragment} from 'react';
import {BrowserRouter, Routes, Route, Outlet} from 'react-router-dom';

//pages
import Home from './pages/Home';
// Single-page app: About and Contact sections are part of Home; no separate routes
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';


import './assets/css/style.css';
import 'react-modal-video/scss/modal-video.scss';
import Header from './components/Header';
import AnimatedCursor from './elements/AnimatedCursor';

let basename = "/";
function App() {
    return (
      <Fragment>
				<BrowserRouter basename={basename}>
					<Routes >
						<Route element= {<Layouts/>} >
								<Route path="/" element = {<Home />} />
						</Route>
					</Routes>
		  <AnimatedCursor />
		  <ScrollToTop />
        </BrowserRouter>
      </Fragment>
    );
}

function Layouts(){
	return(
		<>
			<div className='page-wraper'>
				<Header style="header-transparent"/>
				<Outlet />
				<Footer />
			</div>			
		</>
	)
}

export default App;
